import React from "react";
import { getData } from "../../requests/CRUD";
import { TEAM } from "../../consts/tables";
import Modal from "../Modal/Modal";

const FIELDS = [
  { key: "BUYER_POOL", label: "Buyer Pool" },
  { key: "QUALIFICATIONS", label: "Qualifications" },
  { key: "RECOMMENDATIONS", label: "Recommendations & Timing" },
  { key: "STRENGTHS", label: "Strengths" },
  { key: "CHALLENGES", label: "Challenges" },
];

const CONDITION_TYPES = [
  { value: "category", label: "Property Category" },
  { value: "team_members", label: "Team Members" },
  { value: "state", label: "Property State" },
  { value: "team_members_state", label: "Team Members + Property State" },
];

const CATEGORY_OPTIONS = [
  { value: "retail", label: "Retail" },
  { value: "industrial", label: "Industrial" },
  { value: "office", label: "Office" },
];

const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA",
  "KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT",
  "VA","WA","WV","WI","WY","DC",
];

const STATE_NAMES = {
  AL:"Alabama",AK:"Alaska",AZ:"Arizona",AR:"Arkansas",CA:"California",CO:"Colorado",
  CT:"Connecticut",DE:"Delaware",FL:"Florida",GA:"Georgia",HI:"Hawaii",ID:"Idaho",
  IL:"Illinois",IN:"Indiana",IA:"Iowa",KS:"Kansas",KY:"Kentucky",LA:"Louisiana",
  ME:"Maine",MD:"Maryland",MA:"Massachusetts",MI:"Michigan",MN:"Minnesota",MS:"Mississippi",
  MO:"Missouri",MT:"Montana",NE:"Nebraska",NV:"Nevada",NH:"New Hampshire",NJ:"New Jersey",
  NM:"New Mexico",NY:"New York",NC:"North Carolina",ND:"North Dakota",OH:"Ohio",OK:"Oklahoma",
  OR:"Oregon",PA:"Pennsylvania",RI:"Rhode Island",SC:"South Carolina",SD:"South Dakota",
  TN:"Tennessee",TX:"Texas",UT:"Utah",VT:"Vermont",VA:"Virginia",WA:"Washington",
  WV:"West Virginia",WI:"Wisconsin",WY:"Wyoming",DC:"District of Columbia",
};

function getDefaultConfig() {
  return {
    defaults: {
      BUYER_POOL:
        "Local, Regional, National Private Capital Buyers - Many of Whom are in 1031 Exchanges\nInternational Buyers Looking to Add US Real Estate into Their Portfolio\nInstitutional Capital Targeting Quality, Stabilized Real Estate",
      QUALIFICATIONS:
        "Summit RE: Most Active Commercial Investment Team in Texas & Surrounding States\nTrack Record: We Close Transactions - Sold More Than 1,675 Properties\nSummit Team Controls the Entire Process - Underwriting & Financial Analysts, Full Marketing Dept, Transaction Coordinators, and Team of Agents to Ensure High Probability of Closing\n100% Cooperation - More Brokers & Buyers = More Offers = Higher Price\nAbility to Source Qualified Debt Thru Peak Capital",
      RECOMMENDATIONS:
        "Sell Now to Take Advantage of the Current Market to Eliminate Interest Rates Risk and Capitalize on 1031 Buyers\nIf Awarded the Assignment, We Can Be on the Market Within One Week and Closed Within Our Average List-to-Close Time Frame of 5-6 Months",
      STRENGTHS: "",
      CHALLENGES: "",
    },
    overrides: [],
  };
}

function cloneConfig(config) {
  if (!config) return getDefaultConfig();
  return JSON.parse(JSON.stringify(config));
}

function getInitialConditionValue(type) {
  if (type === "team_members") return [];
  if (type === "state") return [];
  if (type === "team_members_state") return { teamMembers: [], states: [] };
  return "";
}

function createEmptyOverride() {
  return {
    id: Date.now() + "_" + Math.random().toString(36).slice(2, 7),
    name: "",
    conditionType: "category",
    conditionValue: "",
    fields: {},
    collapsed: false,
  };
}

export default class StandardText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: cloneConfig(props.config),
      teamMembers: [],
      teamLoading: true,
      dragIndex: null,
      isDirty: false,
      pickerOpenIndex: null,
      pickerSearch: "",
      showHelp: false,
    };
    this.dragItem = React.createRef();
    this.dragOverItem = React.createRef();
    this.pickerRef = React.createRef();
    this._handleOutsideClick = this._handleOutsideClick.bind(this);
  }

  componentDidMount() {
    this.fetchTeamMembers();
    document.addEventListener("mousedown", this._handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this._handleOutsideClick);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.config !== this.props.config && !this.state.isDirty) {
      this.setState({ config: cloneConfig(this.props.config) });
    }
  }

  _handleOutsideClick(e) {
    if (
      this.state.pickerOpenIndex !== null &&
      this.pickerRef.current &&
      !this.pickerRef.current.contains(e.target)
    ) {
      this.setState({ pickerOpenIndex: null, pickerSearch: "" });
    }
  }

  fetchTeamMembers() {
    getData({
      tableCode: TEAM,
      options: {
        column: ["FIRST_NAME", "LAST_NAME", "EMAIL", "ARCIMEDES_ROW_ID"],
        limit: { count: 1000 },
      },
    })
      .then((res) => {
        if (res && res.success && Array.isArray(res.data)) {
          const members = res.data
            .filter((m) => m.FIRST_NAME || m.LAST_NAME)
            .map((m) => ({
              id: String(m.ARCIMEDES_ROW_ID),
              firstName: m.FIRST_NAME || "",
              name: [m.FIRST_NAME, m.LAST_NAME].filter(Boolean).join(" "),
              email: m.EMAIL || "",
            }))
            .sort((a, b) =>
              a.firstName.localeCompare(b.firstName, undefined, { sensitivity: "base" })
            );
          this.setState({ teamMembers: members, teamLoading: false });
        } else {
          this.setState({ teamMembers: [], teamLoading: false });
        }
      })
      .catch(() => this.setState({ teamMembers: [], teamLoading: false }));
  }

  _updateConfig(updater) {
    if (this.props.readOnly) return;
    this.setState((prev) => {
      const config = cloneConfig(prev.config);
      updater(config);
      return { config, isDirty: true };
    });
  }

  handleSave() {
    if (this.props.onSave) {
      this.props.onSave(this.state.config);
      this.setState({ isDirty: false });
    }
  }

  handleDefaultChange(key, value) {
    this._updateConfig((c) => { c.defaults[key] = value; });
  }

  handleOverrideChange(index, updates) {
    this._updateConfig((c) => {
      c.overrides[index] = { ...c.overrides[index], ...updates };
    });
  }

  handleOverrideFieldToggle(overrideIndex, fieldKey, enabled) {
    this._updateConfig((c) => {
      const fields = { ...c.overrides[overrideIndex].fields };
      if (enabled) {
        fields[fieldKey] = c.defaults[fieldKey] || "";
      } else {
        delete fields[fieldKey];
      }
      c.overrides[overrideIndex].fields = fields;
    });
  }

  handleOverrideFieldValue(overrideIndex, fieldKey, value) {
    this._updateConfig((c) => {
      c.overrides[overrideIndex].fields = { ...c.overrides[overrideIndex].fields, [fieldKey]: value };
    });
  }

  addOverride() {
    this._updateConfig((c) => { c.overrides.push(createEmptyOverride()); });
  }

  removeOverride(index) {
    this._updateConfig((c) => { c.overrides.splice(index, 1); });
  }

  toggleOverrideCollapse(index) {
    this.setState((prev) => {
      const config = cloneConfig(prev.config);
      config.overrides[index].collapsed = !config.overrides[index].collapsed;
      return { config };
    });
  }

  handleTeamMemberToggle(overrideIndex, memberId) {
    this._updateConfig((c) => {
      const override = c.overrides[overrideIndex];
      if (override.conditionType === "team_members_state") {
        const cv = override.conditionValue || { teamMembers: [], states: [] };
        let members = Array.isArray(cv.teamMembers) ? [...cv.teamMembers] : [];
        if (members.includes(memberId)) {
          members = members.filter((id) => id !== memberId);
        } else {
          members.push(memberId);
        }
        override.conditionValue = { ...cv, teamMembers: members };
      } else {
        let current = Array.isArray(override.conditionValue) ? [...override.conditionValue] : [];
        if (current.includes(memberId)) {
          current = current.filter((id) => id !== memberId);
        } else {
          current.push(memberId);
        }
        override.conditionValue = current;
      }
    });
  }

  handleStateToggle(overrideIndex, stateCode) {
    this._updateConfig((c) => {
      const override = c.overrides[overrideIndex];
      // "state" holds a plain array; "team_members_state" holds { teamMembers, states }
      if (override.conditionType === "state") {
        const current = Array.isArray(override.conditionValue) ? [...override.conditionValue] : [];
        override.conditionValue = current.includes(stateCode)
          ? current.filter((s) => s !== stateCode)
          : [...current, stateCode];
      } else {
        const cv = override.conditionValue || { teamMembers: [], states: [] };
        const states = Array.isArray(cv.states) ? [...cv.states] : [];
        const nextStates = states.includes(stateCode)
          ? states.filter((s) => s !== stateCode)
          : [...states, stateCode];
        override.conditionValue = { ...cv, states: nextStates };
      }
    });
  }

  onDragStart(index) {
    if (this.props.readOnly) return;
    this.dragItem.current = index;
    this.setState({ dragIndex: index });
  }

  onDragEnter(index) {
    this.dragOverItem.current = index;
  }

  onDragEnd() {
    const dragIdx = this.dragItem.current;
    const hoverIdx = this.dragOverItem.current;
    if (dragIdx === null || hoverIdx === null || dragIdx === hoverIdx) {
      this.setState({ dragIndex: null });
      return;
    }
    this._updateConfig((c) => {
      const [removed] = c.overrides.splice(dragIdx, 1);
      c.overrides.splice(hoverIdx, 0, removed);
    });
    this.dragItem.current = null;
    this.dragOverItem.current = null;
    this.setState({ dragIndex: null });
  }

  renderTeamMemberPicker(overrideIndex, selectedIds) {
    const { teamMembers, teamLoading, pickerOpenIndex, pickerSearch } = this.state;
    const selected = Array.isArray(selectedIds) ? selectedIds : [];
    const pickerKey = "team_" + overrideIndex;
    const isOpen = pickerOpenIndex === pickerKey;
    if (teamLoading) return <div className="ST_picker_loading">Loading team members...</div>;

    const searchLower = (pickerSearch || "").toLowerCase();
    const available = teamMembers.filter(
      (m) => !selected.includes(m.id) && (!searchLower || m.name.toLowerCase().includes(searchLower))
    );

    return (
      <div className="ST_picker" ref={isOpen ? this.pickerRef : undefined}>
        <div
          className={`ST_picker_selected${isOpen ? " open" : ""}`}
          onClick={() =>
            this.setState({
              pickerOpenIndex: isOpen ? null : pickerKey,
              pickerSearch: "",
            })
          }
        >
          {selected.length === 0 && (
            <span className="ST_picker_placeholder">Select team members...</span>
          )}
          {selected.map((id) => {
            const member = teamMembers.find((m) => m.id === id);
            return (
              <span key={id} className="ST_picker_tag">
                {member ? member.name : id}
                <button
                  className="ST_picker_tag_remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleTeamMemberToggle(overrideIndex, id);
                  }}
                >
                  &times;
                </button>
              </span>
            );
          })}
          <span className="ST_picker_arrow">{isOpen ? "\u25B2" : "\u25BC"}</span>
        </div>
        {isOpen && (
          <div className="ST_picker_dropdown">
            <input
              className="ST_picker_search"
              type="text"
              placeholder="Search team members..."
              value={pickerSearch}
              autoFocus
              onChange={(e) => this.setState({ pickerSearch: e.target.value })}
              onClick={(e) => e.stopPropagation()}
            />
            {available.length === 0 && (
              <div className="ST_picker_empty">No matches found</div>
            )}
            {available.map((m) => (
              <div
                key={m.id}
                className="ST_picker_option"
                onClick={() => this.handleTeamMemberToggle(overrideIndex, m.id)}
              >
                {m.name}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  renderStatePicker(overrideIndex, selectedStates) {
    const { pickerOpenIndex, pickerSearch } = this.state;
    const selected = Array.isArray(selectedStates) ? selectedStates : [];
    const pickerKey = "state_" + overrideIndex;
    const isOpen = pickerOpenIndex === pickerKey;

    const searchLower = (pickerSearch || "").toLowerCase();
    const available = US_STATES.filter(
      (s) => !selected.includes(s) && (!searchLower || s.toLowerCase().includes(searchLower) || (STATE_NAMES[s] || "").toLowerCase().includes(searchLower))
    );

    return (
      <div className="ST_picker" ref={isOpen ? this.pickerRef : undefined}>
        <div
          className={`ST_picker_selected${isOpen ? " open" : ""}`}
          onClick={() =>
            this.setState({
              pickerOpenIndex: isOpen ? null : pickerKey,
              pickerSearch: "",
            })
          }
        >
          {selected.length === 0 && (
            <span className="ST_picker_placeholder">Select states...</span>
          )}
          {selected.map((s) => (
            <span key={s} className="ST_picker_tag">
              {s}
              <button
                className="ST_picker_tag_remove"
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleStateToggle(overrideIndex, s);
                }}
              >
                &times;
              </button>
            </span>
          ))}
          <span className="ST_picker_arrow">{isOpen ? "\u25B2" : "\u25BC"}</span>
        </div>
        {isOpen && (
          <div className="ST_picker_dropdown">
            <input
              className="ST_picker_search"
              type="text"
              placeholder="Search states..."
              value={pickerSearch}
              autoFocus
              onChange={(e) => this.setState({ pickerSearch: e.target.value })}
              onClick={(e) => e.stopPropagation()}
            />
            {available.length === 0 && (
              <div className="ST_picker_empty">No matches found</div>
            )}
            {available.map((s) => (
              <div
                key={s}
                className="ST_picker_option"
                onClick={() => this.handleStateToggle(overrideIndex, s)}
              >
                {STATE_NAMES[s] || s} ({s})
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  renderOverrideCard(override, index) {
    const isCollapsed = override.collapsed;
    return (
      <div
        key={override.id || index}
        className={`ST_rule${this.state.dragIndex === index ? " dragging" : ""}`}
        draggable={!this.props.readOnly}
        onDragStart={() => this.onDragStart(index)}
        onDragEnter={() => this.onDragEnter(index)}
        onDragEnd={() => this.onDragEnd()}
        onDragOver={(e) => e.preventDefault()}
      >
        <div className="ST_rule_header" onClick={() => this.toggleOverrideCollapse(index)}>
          {!this.props.readOnly && <span className="ST_rule_drag" title="Drag to reorder">&#x2261;</span>}
          <input
            className="ST_rule_name"
            type="text"
            placeholder="Rule name..."
            value={override.name || ""}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => this.handleOverrideChange(index, { name: e.target.value })}
          />
          <span className="ST_rule_collapse">{isCollapsed ? "\u25B6" : "\u25BC"}</span>
          {!this.props.readOnly && (
            <button
              className="ST_rule_delete"
              onClick={(e) => {
                e.stopPropagation();
                this.removeOverride(index);
              }}
            >
              Delete
            </button>
          )}
        </div>

        {!isCollapsed && (
          <div className="ST_rule_body">
            <div className="ST_rule_condition">
              <span className="ST_rule_condition_label">When:</span>
              <select
                className="ST_rule_condition_type"
                value={override.conditionType || "category"}
                onChange={(e) =>
                  this.handleOverrideChange(index, {
                    conditionType: e.target.value,
                    conditionValue: getInitialConditionValue(e.target.value),
                  })
                }
              >
                {CONDITION_TYPES.map((ct) => (
                  <option key={ct.value} value={ct.value}>
                    {ct.label}
                  </option>
                ))}
              </select>

              {override.conditionType === "category" && (
                <select
                  className="ST_rule_condition_value"
                  value={override.conditionValue || ""}
                  onChange={(e) =>
                    this.handleOverrideChange(index, { conditionValue: e.target.value })
                  }
                >
                  <option value="">Select category...</option>
                  {CATEGORY_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              )}

              {override.conditionType === "team_members" &&
                this.renderTeamMemberPicker(index, override.conditionValue)}

              {override.conditionType === "state" &&
                this.renderStatePicker(index, override.conditionValue)}

              {override.conditionType === "team_members_state" && (
                <div className="ST_combined_condition">
                  <div className="ST_combined_condition_row">
                    <span className="ST_combined_condition_label">Team Members:</span>
                    {this.renderTeamMemberPicker(
                      index,
                      override.conditionValue && override.conditionValue.teamMembers
                        ? override.conditionValue.teamMembers
                        : []
                    )}
                  </div>
                  <div className="ST_combined_condition_row">
                    <span className="ST_combined_condition_label">Property State:</span>
                    {this.renderStatePicker(
                      index,
                      override.conditionValue && override.conditionValue.states
                        ? override.conditionValue.states
                        : []
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="ST_rule_fields">
              {FIELDS.map((field) => {
                const isActive = override.fields.hasOwnProperty(field.key);
                return (
                  <div key={field.key} className="ST_rule_field">
                    <label className="ST_rule_field_toggle">
                      <input
                        type="checkbox"
                        checked={isActive}
                        onChange={(e) =>
                          this.handleOverrideFieldToggle(index, field.key, e.target.checked)
                        }
                      />
                      <span>{field.label}</span>
                    </label>
                    {isActive && (
                      <textarea
                        className="ST_textarea"
                        rows={4}
                        value={override.fields[field.key] || ""}
                        onChange={(e) =>
                          this.handleOverrideFieldValue(index, field.key, e.target.value)
                        }
                        placeholder={`Enter ${field.label.toLowerCase()} text... (one bullet per line)`}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { config, isDirty, showHelp } = this.state;
    const { saving, readOnly } = this.props;
    const defaults = config.defaults || {};
    const overrides = config.overrides || [];

    return (
      <div className="StandardText">
        <div className="ST_page_header">
          <div className="ST_page_header_text">
            <h2 className="ST_page_header_title">Standard Text</h2>
            <p className="ST_page_header_subtitle">
              Manage the default text that appears in the Proposal tab of every new property.
            </p>
          </div>
          <button
            className="ST_help_btn"
            onClick={() => this.setState({ showHelp: true })}
            title="How does this work?"
          >
            ?
          </button>
        </div>

        <Modal
          show={showHelp}
          onClose={() => this.setState({ showHelp: false })}
          className="ST_help_modal"
        >
          <div className="ST_help_content">
            <div className="ST_help_header">
              <h2 className="ST_help_title">Standard Text &mdash; Proposals</h2>
              <button
                className="ST_help_close"
                onClick={() => this.setState({ showHelp: false })}
              >
                &times;
              </button>
            </div>
            <div className="ST_help_body">
              <p>
                This section lets you manage the default text that appears in the Proposal tab
                of every new property. Instead of updating text through code changes, you can now
                edit it directly from here.
              </p>

              <h3>How it works</h3>

              <div className="ST_help_item">
                <h4>Default Proposal Text</h4>
                <p>
                  These are the base bullet points (Buyer Pool, Qualifications, Recommendations
                  &amp; Timing, Strengths, Challenges) that automatically populate when a new
                  property is created. Edit any field and click &ldquo;Save Changes&rdquo; to
                  update the defaults going forward.
                </p>
              </div>

              <div className="ST_help_item">
                <h4>Conditional Overrides</h4>
                <p>
                  Sometimes you need different wording for specific situations. You can create
                  rules that automatically swap in different text when a condition is met. There
                  are three condition types:
                </p>
                <ul>
                  <li>
                    <strong>Property Category</strong> &mdash; applies when the property matches
                    a specific category (Retail, Industrial, Office).
                  </li>
                  <li>
                    <strong>Team Members</strong> &mdash; applies when the property is assigned
                    to specific team members, or when those team members are logged in.
                  </li>
                  <li>
                    <strong>Team Members + Property State</strong> &mdash; applies when specific
                    team members are involved AND the property is in a specific state. For
                    example, a rule for the SoCal team + California properties will only change
                    the text when both conditions are true.
                  </li>
                </ul>
                <p>
                  Rules are applied in order from top to bottom &mdash; if two rules overlap,
                  the one lower on the list wins.
                </p>
              </div>

              <h3>Keep in mind</h3>
              <ul className="ST_help_tips">
                <li>
                  Changes here only affect <strong>new properties</strong> going forward.
                  Properties where the proposal text has already been manually edited will keep
                  their custom text.
                </li>
                <li>
                  You can add as many override rules as you need and reorder them by dragging.
                </li>
                <li>
                  When selecting team members or states for a rule, use the search box to
                  quickly find what you&rsquo;re looking for.
                </li>
                <li>
                  Don&rsquo;t forget to hit &ldquo;Save Changes&rdquo; when you&rsquo;re done
                  editing &mdash; changes are not saved automatically.
                </li>
              </ul>
            </div>
          </div>
        </Modal>

        {/* A read-only viewer (a Partner) sees the text; the fieldset disables every control in it. */}
        <fieldset disabled={!!readOnly} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
        <section className="ST_section">
          <div className="ST_section_header">
            <h2 className="ST_section_title">Default Proposal Text</h2>
            <p className="ST_section_desc">
              This text is automatically applied to new properties. Each line becomes a bullet
              point.
            </p>
          </div>
          <div className="ST_defaults">
            {FIELDS.map((field) => (
              <div key={field.key} className="ST_field">
                <label className="ST_field_label">{field.label}</label>
                <textarea
                  className="ST_textarea"
                  rows={field.key === "STRENGTHS" || field.key === "CHALLENGES" ? 2 : 4}
                  value={defaults[field.key] || ""}
                  onChange={(e) => this.handleDefaultChange(field.key, e.target.value)}
                  placeholder={`Enter default ${field.label.toLowerCase()}... (one bullet per line)`}
                />
              </div>
            ))}
          </div>
        </section>

        <section className="ST_section">
          <div className="ST_section_header">
            <h2 className="ST_section_title">Conditional Overrides</h2>
            <p className="ST_section_desc">
              Create rules to automatically adjust text for specific teams or property types.
              Rules are applied top to bottom &mdash; later rules take priority.
            </p>
          </div>
          <div className="ST_overrides">
            {overrides.map((override, i) => this.renderOverrideCard(override, i))}
            {!readOnly && (
              <button className="ST_add_rule" onClick={() => this.addOverride()}>
                + Add Rule
              </button>
            )}
          </div>
        </section>

        </fieldset>

        {isDirty && !readOnly && (
          <div className="ST_save_bar">
            <span className="ST_save_bar_label">You have unsaved changes</span>
            <button
              className="ST_save_bar_btn"
              disabled={saving}
              onClick={() => this.handleSave()}
            >
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        )}
      </div>
    );
  }
}

export { getDefaultConfig };
